import { changeCustomerSelectCustomerContainerStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { css } from "styled-components";

Object.assign(changeCustomerSelectCustomerContainerStyles, {
    ...changeCustomerSelectCustomerContainerStyles,
    billToSelectorGridItem: {
        width: 12,
        css: css`
            label {
                font-size: 16px;
                margin-bottom: 3px;
            }
            div[class^="FormInputWrapper"] {
                span[data-test-selector="changeCustomerBillToSelector-selectedText"] {
                    font-size: 14px;
                }
                ul[data-test-selector="changeCustomerBillToSelector-listbox"] {
                    div[class^="Option"] {
                        font-size: 14px;
                        :hover {
                            background-color: #f7f7f7;
                        }
                    }
                    div[aria-selected="true"] {
                        color: #444;
                        background-color: #f0f0f0;
                    }
                }
            }
        `,
    },
    shipToSelectorGridItem: {
        width: 12,
        css: css`
            label {
                font-size: 16px;
                margin-bottom: 3px;
            }
            div[class^="FormInputWrapper"] {
                span[data-test-selector="changeCustomerShipToSelector-selectedText"] {
                    font-size: 14px;
                }
                ul[data-test-selector="changeCustomerShipToSelector-listbox"] {
                    div[class^="Option"] {
                        font-size: 14px;
                        :hover {
                            background-color: #f7f7f7;
                        }
                    }
                    div[aria-selected="true"] {
                        color: #444;
                        background-color: #f0f0f0;
                    }
                }
            }
        `,
    },
    useDefaultCustomerGridItem: {
        width: 12,
        css: css`
            padding: 0 15px;
            div[id="setDefaultCustomer-description"] {
                font-size: 14px;
            }
        `,
    },
    useDefaultCustomerCheckboxGroup: {
        css: css`
            label {
                font-size: 14px;
            }
        `,
    },
    fulfillmentMethodSelectorGridItem: {
        width: 12,
        css: css`
            padding: 0;
        `,
    },
    cancelButton: {
        css: css`
            margin-right: 15px;
            background-color: #999;
            border: none;
            :hover {
                background-color: #999;
            }
        `,
    },
    continueButton: {
        css: css`
            padding: 10px 17px;
            :hover {
                background-color: #ab161a;
                border-color: #ab161a;
            }
        `,
    },
});
